import React from "react"
import { AlertsList } from "./AlertsList"
import { useFeed } from "../../Hooks/useFeed"
import { MobergButton, MobergButtonShape, MobergButtonVariant, MobergIconSize, MobergText, MobergTheme } from "../../../../../../Moberg"
import { MdNotifications } from "react-icons/md"
import { useModalProvider } from "../../../../../../Providers/ModalProvider"
import { useAlertsProvider } from "../../../../../../Providers/AlertsProvider"

export const AlertsFeed = () => {
    const { alerts, getAlertTheme, setSelectedAlertId } = useAlertsProvider()
    const sortedAlerts = [...alerts].sort((a, b) => a.timestamp < b.timestamp ? 1 : -1) // latest first
    const feedItems = sortedAlerts.filter(alert => !alert.silenced)

    const currentAlert = useFeed(feedItems, { cycleTimeSeconds: 5 })
    const { createModal } = useModalProvider()

    if (!currentAlert) {
        return (
            <MobergButton shape={MobergButtonShape.SQUARE} theme={MobergTheme.BLUE} onClick={() => {
                setSelectedAlertId(sortedAlerts[0]?.id)
                createModal(<AlertsList />)
            }}>
                <MdNotifications size={MobergIconSize.REGULAR} />
            </MobergButton>
        )
    }

    return (
        <MobergButton key={currentAlert.id} theme={getAlertTheme(currentAlert)} variant={MobergButtonVariant.FILLED}
            style={{ overflow: "hidden", paddingLeft: "8px", minWidth: "250px", maxWidth: "400px", textOverflow: "ellipsis", justifyContent: "left" }}
            onClick={() => {
                setSelectedAlertId(currentAlert.id)
                createModal(<AlertsList />)
            }}>
            <MdNotifications size={MobergIconSize.REGULAR} />
            <MobergText style={{ minWidth: 0 }}>{currentAlert.title}</MobergText>
        </MobergButton>
    )
}